<template>
  <div>
    <form method="post" @submit="saveRequest" id="requestForm" novalidate class="needs-validation">
      <h4>Ready to book dates?</h4>
      <p>
        Fill in the following information below <br> and the reservation specialist will get <br> back to you in the next
        24 hours.
      </p>
      <div class="row">
        <div class="col-12 mb-3">
          <label class="form-label">First Name</label>
          <input class="form-control" type="text" v-model="form.firstName" required />
          <span class="form-text invalid-feedback">Please provide your first name</span>
        </div>
        <div class="col-12 mb-3">
          <label class="form-label">Last Name</label>
          <input class="form-control" type="text" v-model="form.lastName" required />
          <span class="form-text invalid-feedback">Please provide your last name</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mb-3">
          <label class="form-label">Email</label>
          <input class="form-control" type="email" v-model="form.email" required />
          <span class="form-text invalid-feedback">Provide your email addrees where you would like to receive your
            quote</span>
        </div>
        <div class="col-12 mb-3">
          <label class="form-label">Phone Number</label>
          <input class="form-control" type="text" v-model="form.phone" required maxlength="10" minlength="10"
            pattern="^\d{10}$" />
          <span class="form-text invalid-feedback">Please provide your phone number</span>
        </div>
        <div class="col-12 mb-3">
          <label class="form-label">Certificate Number</label>
          <input class="form-control" type="text" v-model="form.certificateNumber" required />
          <span class="form-text invalid-feedback">Please provide your Certificate Number</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mb-3">
          <label class="form-label">Comments</label>
          <textarea class="form-control" rows="2" v-model="form.comments"></textarea>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-8 ">
          <button type="submit" class="btn btn-green w-100">Submit</button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
export default {
  data() {
    return {
      form: this.initialValues(),
      saved: false,
      waiting: false,
      childrenAges: [],
      leadTypeID: 109,
        leadSourceChannelID:  localStorage.getItem('utm_medium'),
        leadSourceID: localStorage.getItem('utm_source'),
        campaignName: localStorage.getItem('utm_campaign'),
    };
  },
  watch: {
    "form.children": function (newVal) {
      this.childrenAges = [];
      for (let i = 0; i < newVal; i++) {
        this.childrenAges.push({
          childrenIndex: i,
          age: null,
        });
      }
    },
  },
  methods: {
    saveRequest(e) {
      let form = e.target;
      if (form.checkValidity() === true) {
        this.waiting = true;
        this.loadingMessage()
        var url =
          "https://hooks.zapier.com/hooks/catch/4763102/3nqnlox/";
        var data = this.form;
        data.notes = "";
        data.notes += `Certificate Number: ${this.form.certificateNumber}`;
        data.notes += `<br>Comments: ${this.form.comments}`;
        fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          // headers: {
          //   "Content-Type": "application/json",
          // },
        })
          .then(() => {
            this.successMessage();
            this.resetValues();
            this.triggerGTM()
            this.waiting = false;
            this.saved = true;
            window.gtag_report_conversion_qr();
          })
          .catch(() => {
            this.waiting = false;
            this.errorMessage()
          });
      }
      form.classList.add("was-validated");
      e.preventDefault();
    },
    // validEmail(email) {
    //   var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return re.test(email);
    // },
    triggerGTM() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'form_success', 'formname': 'redeem_package', 'corporate': 'tafer' });
    },
    resetValues() {
      this.form = this.initialValues();
      document.getElementById("requestForm").classList.remove("was-validated");
    },
    loadingMessage() {
      this.loading = Swal.mixin({
        customClass: {
          loader: 'spinner',
        }
      })
      return this.loading.fire({
        text: "Submitting",
        showConfirmButton: false,
        iconColor: "##0B6482",
        backdrop: `rgba(0,0,0,0.5)`,
        width: 160,
        timerProgressBar: true,
        // timer: 3000,
        didOpen: () => {
          this.loading.showLoading();
        },
      });
    },
    successMessage() {
      this.tab = 3
      return Swal.fire({
        icon: "success",
        title: "Thanks, all set.",
        text: "An agent will be in touch with you soon.",
        color: "#0B6482",
        showConfirmButton: false,
        timer: 5000,
        iconColor: "#0B6482",
        backdrop: `rgba(0,0,0,0.5)`,
        customClass: {
          title: 'sweetAlerTitle',
          icon: 'successIcon',
        }
      });
    },
    errorMessage() {
      return Swal.fire({
        icon: "warning",
        title: "Oops",
        text: "An unexpected error ocurred, please try again.",
        color: "#0B6482",
        iconColor: "#ffd700",
        showConfirmButton: false,
        // timer: 5000,
        backdrop: `rgba(0,0,0,0.5)`,
      });
    },
    initialValues() {
      return {
        webhookID: "79e7f5d1-f914-c704-f9b8-df3b572758a2",
        firstName: null,
        lastName: null,
        certificateNumber: null,
        comments: null,
        notes: null,
      };
    },
  },
  mounted() {

  },
};
</script>
